import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import $ from 'jquery'
import ExchangeRateActions from '../../Redux/ExchangeRateRedux'

class ExchangeRate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      filter: {
        from: '',
        to: '',
        manual_updated: ''
      },
      detail: {},
      form: {
        rate: 0
      }
    }
  }

  componentDidMount = () => {
    this.props.getExchangeRate()
  }

  _filterChange = (event, field) => {
    let newState = { ...this.state.filter }
    let val = event.target.value
    newState[field] = val
    this.setState({ filter: newState })

    if (field === 'from') {
      $.expr[':'].contains = function (a, i, m) {
        return $(a).text().toUpperCase()
          .indexOf(m[3].toUpperCase()) >= 0
      }
      if (val) {
        $('td[data-filter="from"]:not(:contains("' + val + '"))').parent().hide()
        $('td[data-filter="from"]:contains("' + val + '")').parent().show()
      } else {
        $('tr:hidden').show()
      }
    }

    if (field === 'to') {
      $.expr[':'].contains = function (a, i, m) {
        return $(a).text().toUpperCase()
          .indexOf(m[3].toUpperCase()) >= 0
      }
      if (val) {
        $('td[data-filter="to"]:not(:contains("' + val + '"))').parent().hide()
        $('td[data-filter="to"]:contains("' + val + '")').parent().show()
      } else {
        $('tr:hidden').show()
      }
    }

    if (field === 'manual_updated') {
      $.expr[':'].contains = function (a, i, m) {
        return $(a).text().toUpperCase()
          .indexOf(m[3].toUpperCase()) >= 0
      }
      if (val) {
        $('td[data-filter="manual_updated"]:not(:contains("' + val + '"))').parent().hide()
        $('td[data-filter="manual_updated"]:contains("' + val + '")').parent().show()
      } else {
        $('tr:hidden').show()
      }
    }
  }

  _selectItem = (item, action) => {
    let form = { ...this.state.form }
    form['rate'] = item.rate
    this.setState({ detail: item, form })
    this._toggleModal(action)
  }

  _toggleModal = (modalId) => {
    this.setState({ showModal: modalId })
    // if (!modalId) {
    //   this.props.getExchangeRate()
    // }
  }

  _fieldChange = (event, field) => {
    let form = { ...this.state.form }
    let val = event.target.value
    if (event.target.type === 'number') {
      val = parseFloat(val)
    }
    form[field] = val
    this.setState({ form })
  }

  _updateRate = (event) => {
    event.preventDefault()
    const data = {
      id: this.state.detail.id,
      form: this.state.form
    }
    this.props.updateExchangeRate(data)
    this._toggleModal()
  }

  render () {
    const { exchangeRate } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3'>
            <h3 className='title mr-auto'>
              Exchange Rate List
              {exchangeRate.fetching &&
                <div className='badge badge-info ml-2'>Loading ...</div>
              }
            </h3>
          </div>
          <div className='title-block'>
            <p className='title-description'>Filter:</p>
            <div className='form-inline'>
              <div className='form-group mr-2'>
                <label htmlFor='from' className='control-label mr-2'>From</label>
                <input type='text' placeholder='Currency Code' className='form-control' value={this.state.filter.from} onChange={(event) => this._filterChange(event, 'from')} />
              </div>
              <div className='form-group mr-2'>
                <label htmlFor='from' className='control-label mr-2'>To</label>
                <input type='text' placeholder='Currency Code' className='form-control' value={this.state.filter.to} onChange={(event) => this._filterChange(event, 'to')} />
              </div>
              <div className='form-group'>
                <label htmlFor='from' className='control-label mr-2'>Manual Updated</label>
                <select value={String(this.state.filter.manual_updated)} className='form-control' onChange={(event) => this._filterChange(event, 'manual_updated')}>
                  <option value=''>- ALL -</option>
                  <option value='true'>True</option>
                  <option value='false'>False</option>
                </select>
              </div>
            </div>
          </div>
        </header>
        <div className='section'>
          <div className='card'>
            {!(exchangeRate.fetching || exchangeRate.processing) && exchangeRate.err &&
              <div className='alert alert-danger'>{exchangeRate.err}</div>
            }
            <div className='card-block'>
              <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                <thead>
                  <tr>
                    <th>From</th>
                    <th>To</th>
                    <th>Rate</th>
                    <th>Manual Updated</th>
                    <th className='text-center'>Update</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    !exchangeRate.data
                      ? <tr>
                        <td colSpan='5' className='text-center'>- No Data -</td>
                      </tr>
                      : exchangeRate.data.map((item, i) => (
                        <tr key={i}>
                          <td data-filter='from'>{item.from || '-'}</td>
                          <td data-filter='to'>{item.to || '-'}</td>
                          <td>{item.rate || 0}</td>
                          <td data-filter='manual_updated'>
                            <label className={`badge badge-${item.manual_updated ? 'success' : 'danger'}`}>
                              {String(item.manual_updated)}
                            </label>
                          </td>
                          <td className='text-center'>
                            <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'update')}>
                              <i className='fas fa-edit' />
                            </button>
                          </td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            </div>
          </div>

          {/* UPDATE MANUAL */}
          <Modal open={this.state.showModal === 'update'} onClose={this._toggleModal} closeOnOverlayClick>
            <div className='section' style={{ width: '25vw' }}>
              <div className='title-block'>
                <h4 className='title mr-auto'>Update Exchange Rate</h4>
              </div>
              <form onSubmit={(event) => this._updateRate(event)}>
                <div className='form-group'>
                  <label className='control-label'>From</label>
                  <input type='text' className='form-control' value={this.state.detail.from} readOnly />
                </div>
                <div className='form-group'>
                  <label className='control-label'>To</label>
                  <input type='text' className='form-control' value={this.state.detail.to} readOnly />
                </div>
                <div className='form-group'>
                  <label className='control-label'>Rate</label>
                  <input type='number' className='form-control' value={this.state.form.rate} onChange={(event) => this._fieldChange(event, 'rate')} />
                </div>
                <div className='form-group text-right'>
                  <button type='button' className='btn btn-secondary' onClick={() => this._toggleModal()}>Cancel</button>
                  <button type='submit' className='btn btn-primary ml-2'>Save</button>
                </div>
              </form>
            </div>
          </Modal>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  exchangeRate: state.exchangeRate
})

const dispatchToProps = (dispatch) => ({
  getExchangeRate: () => dispatch(ExchangeRateActions.exchangeRateRequest()),
  updateExchangeRate: (data) => dispatch(ExchangeRateActions.exchangeRateUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ExchangeRate)



// WEBPACK FOOTER //
// ./src/Pages/Misc/ExchangeRate.js